import { Skeleton } from 'ui/skeleton';
import { dataTestId } from 'modules/experiments/constants';
import { VariantCardFooterWrapper } from './Styled';

export const LoadingFooter = () => (
  <VariantCardFooterWrapper data-test={dataTestId.variantCardFooterLoading}>
    <Skeleton height={25} />
  </VariantCardFooterWrapper>
);
